import React, { useEffect, useState } from "react";
import {
  useAddPaymentMutation,
  useOrderByIdQuery,
  useOrdersQuery,
  usePaymentByIdQuery,
  useStatusQuery,
} from "../../Store/Apis/bookingApi";
import { updateReservation } from "../../Store/Apis/ReservationApi";
import Error from "../../Components/Error/Error";
import Loader from "../../Components/Loader/Loader";
import { Link, useLocation } from "react-router-dom";
import { useOutletsQuery } from "../../Store/Apis/outletApi";
import getStatusColor from "../../Hooks/GetStatusColor";
import {
  isDropdownPermission,
  isPermissionGranted,
} from "../../Hooks/permissionsMiddleware";
import { Table, Badge } from "antd";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import AddPaymentForm from "../../Components/AddPaymentForm/AddPaymentForm";
import { useSelector } from "react-redux";
import formatDate from "../../Hooks/formatDate";
import { useRolesQuery } from "../../Store/Apis/rolePermissionApi";
import SalesMobileHistory from "../../Components/SalesMobileHistory/SalesMobileHistory";

const SalesHistory = () => {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search); // Parse the URL parameters
  const statusFromUrl = urlParams.get("status");
  const [sortFilter, setSortFilter] = useState({
    search: "",
    outlet: "",
    status: "",
    status: statusFromUrl || "",
    technicianID: "",
  });

  const roleIdFromUser = Number(
    user?.role_Id ??
      user?.roleId ??
      user?.roleID ??
      user?.role_id ??
      (typeof user?.role === "number" ? user?.role : NaN)
  );
  const roleNameFromUser = String(
    user?.role || user?.roleName || ""
  ).toLowerCase();
  const isCreditManager =
    roleIdFromUser === 51 ||
    roleNameFromUser === "credit manager" ||
    roleNameFromUser === "credit_manager" ||
    roleNameFromUser === "creditmanager";
  const isBarTenderRole = roleIdFromUser === 7;

  const bookingApi = useOrdersQuery({
    keyword: sortFilter.search,
    statusName: isBarTenderRole ? "Bar sales" : sortFilter.status,
    outletID: sortFilter.outlet,
    technicianID: sortFilter.technicianID,
    // Hint to backend: if Credit Manager, fetch only exceeded; others exclude exceeded
    exceeded_limit: isCreditManager ? "yes" : "no",
  });

  const outletList = useOutletsQuery();
  const statusList = useStatusQuery();
  const roleApi = useRolesQuery();

  // ADD PAYMENT AND UPDATE ORDER
  const [paymentFormModal, setPaymentFormModal] = useState();
  // Replaced RTK mutation with direct Reservation API helper when needed
  const [addPaymentMutation] = useAddPaymentMutation();

  const orderByIdApi = useOrderByIdQuery(
    {
      orderId: paymentFormModal?.orderId,
      outletID: paymentFormModal?.outletId || user?.outletID,
    },
    { skip: !paymentFormModal?.orderId }
  );

  const paymentByIdApi = usePaymentByIdQuery(
    {
      orderId: paymentFormModal?.orderId,
    },
    { skip: !paymentFormModal?.orderId }
  );

  const handleAddPayment = (formData) => {
    console.log(formData);
    addPaymentMutation({
      paymentDate: new Date().toISOString(),
      customerId: orderByIdApi?.data?.data[0].customerID || 0,
      companyID: orderByIdApi?.data?.data[0].companyID || 0,
      customerName: orderByIdApi?.data?.data[0].customerName,
      orderId: paymentFormModal?.orderId,
      receivedAmount: formData.paidAmount,
      payAmount: formData.paidAmount,
      paymentType: formData.paymentType,
      paymentNote: formData.notes,
      utrNumber: formData.utrNumber,
    }).then((res) => {
      console.log(res);
      if (res?.data?.status === 200) {
        setPaymentFormModal(false);
        toast.success(res?.data?.message, { duration: 7000 });
        // navigate('/sales-history');
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    });
  };

  // Define columns for the Ant Design Table
  const columns = [
    {
      title: "Order Info",
      dataIndex: "orderInfo",
      fixed: "left",
      width: 250,
      render: (_, record) => (
        <>
          <p className="text-sm mb-0">
            <span className="me-2">Order ID:</span>
            <span className="font-weight-bold">{record.orderNumber}</span>
          </p>

          <p className="text-sm mb-0">
            <span className="me-2">Check In Date:</span>
            <span>{formatDate(record.orderDate)}</span>
          </p>
          <p className="text-sm mb-0">
            <span className="me-2">Check Out Date:</span>
            <span>{formatDate(record.checkOutDate)}</span>
          </p>
        </>
      ),
    },
    {
      title: "Outlet",
      dataIndex: "outletName",
    },
    {
      title: "Customer",
      dataIndex: "customer",
      render: (_, record) => (
        <>
          <p className="text-sm font-weight-bold mb-0">{record.customerName}</p>
          <p className="text-sm mb-0">{record.customerNumber}</p>
        </>
      ),
    },
    {
      title: "Order Amount",
      dataIndex: "subTotal",
      render: (_, record) => (
        <>
          <p className="text-sm font-weight-bold mb-0">
            <span className="me-2">Order Amount:</span>
            <span className="font-weight-bold">R {record.subTotal}</span>
          </p>
          {/* <p className="text-sm mb-0">
            <span className="me-2">Credited Amount:</span>
            <span className="font-weight-bold text-danger">
              R {record.creditedAmount}
            </span>
          </p> */}
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "statusDescription",
      render: (status) => (
        <span
          className={`badge badge-sm text-uppercase badge-${getStatusColor(
            status
          )}`}
          style={{ cursor: "default" }}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Payment",
      dataIndex: "payment",
      render: (_, record) => (
        <>
          <p className="text-sm mb-0">
            <span className="me-2">Total Amount:</span>
            <span className="font-weight-bold">R {record.netAmount}</span>
          </p>
          <p className="text-xs mb-0">
            <span className="me-2">Credited:</span>
            <span className="font-weight-bold text-danger">
              - R {record.creditedAmount}
            </span>
          </p>
          <p className="text-sm mb-0">
            <span className="me-2">Paid Amount:</span>
            <span className="font-weight-bold">R {record.amountPaid}</span>{" "}
            <br />
            {isPermissionGranted(5) &&
              record.netAmount !== record.amountPaid && (
                <span
                  className="badge badge-xs badge-success text-xs fw-600 mt-2"
                  onClick={() => setPaymentFormModal(record)}
                >
                  Add Payment
                </span>
              )}
          </p>
        </>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      render: (_, record) => (
        <p className="text-sm mb-0">{record.createdByName}</p>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      fixed: "right",
      width: 150,
      render: (_, record) => (
        <>
          {isPermissionGranted(2) && (
            <Link
              to={`/sales-history/details?id=${record.orderId}`}
              className="badge badge-xs badge-primary text-xs fw-600 mx-1 mb-1"
            >
              View
            </Link>
          )}
          {isPermissionGranted(1) &&
            record.statusDescription !== "Completed" &&
            record.statusDescription !== "Checked Out" &&
            (() => {
              // Internal booking: only creator can edit
              if (record.createdBy.toString() !== "0") {
                return record.createdBy.toString() === user.id.toString();
              }
              // External booking (createdBy === 0): only reservationist role can edit
              const userRoleName = String(
                user?.role || user?.roleName || ""
              ).toLowerCase();
              return userRoleName === "reservationist";
            })() && (
              <Link
                to={`/sales-history/edit?id=${record.orderId}`}
                className="badge badge-xs badge-warning text-xs fw-600 mx-1 "
              >
                Edit
              </Link>
            )}
          {isPermissionGranted(2) &&
            record.statusDescription === "Checked In" && (
              <Link
                to={`/sales-history/editCharges?id=${record.orderId}&outletID=${record.outletId}`}
                className="badge badge-xs badge-info text-xs fw-600 mx-1"
              >
                Room Charges
              </Link>
            )}
        </>
      ),
    },
  ];

  // Helper to detect exceeded limit across naming variants
  const hasExceededFlag = (o) => {
    const v1 = o?.exceeded_limit;
    const v2 = o?.exceed_Limit; // legacy
    const v3 = o?.exceededLimit;
    const val = v1 ?? v2 ?? v3;
    if (typeof val === "string") return val.toLowerCase() === "yes";
    if (typeof val === "number") return val === 1;
    if (typeof val === "boolean") return val === true;
    return false;
  };

  // Apply role-based visibility filtering client-side (fallback if server doesn't filter)
  const visibleOrders = (bookingApi?.data?.data || []).filter((o) => {
    if (isCreditManager) {
      return hasExceededFlag(o);
    } else if (isBarTenderRole) {
      // For role ID 7, only show orders with status ID 12 (Bar sales)
      return (
        o.statusID === 12 ||
        o.status_id === 12 ||
        o.statusDescription === "Bar sales"
      );
    } else {
      return !hasExceededFlag(o);
    }
  });

  // Derive company booking dates (earliest subCustomerCheckIn, latest subCustomerCheckOut)
  const deriveCompanyDates = (order) => {
    const services = order?.services || order?.serviceTypeAndName || [];
    const ins = services
      .map((s) => s?.subCustomerCheckIn)
      .filter(Boolean)
      .map((d) => new Date(d));
    const outs = services
      .map((s) => s?.subCustomerCheckOut)
      .filter(Boolean)
      .map((d) => new Date(d));
    const minIn = ins.length ? new Date(Math.min(...ins)) : null;
    const maxOut = outs.length ? new Date(Math.max(...outs)) : null;
    return {
      checkIn: minIn ? minIn.toISOString() : order?.orderDate,
      checkOut: maxOut ? maxOut.toISOString() : order?.checkOutDate,
    };
  };

  // Transform data to fit the Ant Design table structure
  const dataSource = visibleOrders.map((elem, index) => {
    const isCompany = !!elem?.companyID;
    const { checkIn, checkOut } = isCompany
      ? deriveCompanyDates(elem)
      : { checkIn: elem?.orderDate, checkOut: elem?.checkOutDate };

    // Original subtotal (including tax minus discount) kept for payment column consistency
    const rawSubTotal = Number(
      (elem.subTotal || 0) + (elem.taxAmount || 0) - (elem.discount || 0)
    );

    // Aggregate credited amount: prefer order-level value; fall back to sum of line-level creditedAmount
    let creditedAggregate = 0;
    if (
      elem.creditedAmount !== null &&
      elem.creditedAmount !== undefined &&
      !isNaN(elem.creditedAmount)
    ) {
      creditedAggregate = Number(elem.creditedAmount);
    } else if (Array.isArray(elem.serviceTypeAndName)) {
      creditedAggregate = elem.serviceTypeAndName.reduce(
        (sum, s) => sum + (Number(s?.creditedAmount) || 0),
        0
      );
    }

    // Net amount after credit (never below zero)
    const netAmount = Math.max(0, rawSubTotal - creditedAggregate);

    return {
      key: index,
      orderNumber: elem.orderNumber,
      orderDate: checkIn,
      checkOutDate: checkOut,
      outletName: elem.outletName,
      outletId: elem.outletId ?? elem.outletID ?? user?.outletID,
      customerName: elem.customerName,
      customerNumber: elem.customerNumber,
      creditedAmount: creditedAggregate.toFixed(2),
      subTotal: rawSubTotal.toFixed(2), // original subtotal
      netAmount: netAmount.toFixed(2), // subtotal minus credited amount
      statusDescription: elem.statusDescription,
      amountPaid: Number(elem.amountPaid).toFixed(2),
      totalAmount: Number(elem.totalAmount).toFixed(2),
      orderId: elem.orderId,
      createdBy: elem.createdBy,
      createdByName: elem.createdByName,
    };
  });

  useEffect(() => {
    if (isBarTenderRole) {
      // For role ID 7, force the status to Bar sales and disable other filters
      setSortFilter({
        search: "",
        outlet: user.outletID || "",
        status: "Bar sales",
        technicianID: "",
      });
    } else if (user.role !== "superAdmin") {
      setSortFilter({
        ...sortFilter,
        outlet: user.outletID,
        status: statusFromUrl || sortFilter.status,
      });
    }
    if (roleApi.isSuccess && user.role === "Technician") {
      const technicianRole = roleApi.data?.data?.find(
        (elem) => elem.roleName === "Technician"
      );
      setSortFilter((prevFilter) => ({
        ...prevFilter,
        technicianID: technicianRole?.roleID === user.role_Id ? user.id : "",
        status: isBarTenderRole
          ? "Bar sales"
          : statusFromUrl || prevFilter.status,
      }));
    }
  }, [roleApi.isSuccess, statusFromUrl, isBarTenderRole]);

  // If user is Bar Tender (role ID 7), render the mobile component
  if (isBarTenderRole) {
    return <SalesMobileHistory />;
  }

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col">
          <h5 className="fw-500 text-white mb-0">Sales History</h5>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header p-4">
              {/* {isBarTenderRole && (
                <div className="alert alert-info mb-3">
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Bar Tender View:</strong> You are viewing only Bar
                  Sales orders (Status ID 12). Search and outlet filtering are
                  disabled. You can still view details and print invoices for
                  these orders.
                </div>
              )} */}
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Order Id, Outlet and Customer"
                    value={sortFilter?.search || ""}
                    disabled={isBarTenderRole}
                    onChange={(e) =>
                      setSortFilter({ ...sortFilter, search: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-3">
                  <select
                    className="form-select"
                    disabled={
                      !outletList.isSuccess ||
                      user.role_Id !== 10 ||
                      isBarTenderRole
                    }
                    value={sortFilter?.outlet}
                    onChange={(e) =>
                      setSortFilter({ ...sortFilter, outlet: e.target.value })
                    }
                  >
                    <option className="select-box" value="">
                      All Outlets
                    </option>
                    {outletList?.data?.data.map((elem) => {
                      return (
                        <option value={elem.outletId}>{elem.outletName}</option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    className="form-select"
                    value={sortFilter?.status || ""}
                    disabled={isBarTenderRole}
                    onChange={(e) =>
                      setSortFilter({ ...sortFilter, status: e.target.value })
                    }
                  >
                    {isBarTenderRole ? (
                      <option className="select-box" value="Bar sales">
                        Bar Sales
                      </option>
                    ) : (
                      <>
                        <option className="select-box" value="">
                          All Bookings
                        </option>
                        {statusList?.data?.data.map((elem, i) => {
                          return (
                            <option
                              key={i}
                              className="select-box"
                              value={elem.description}
                            >
                              {elem.description}
                            </option>
                          );
                        })}
                      </>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {bookingApi.isError && <Error />}
              {bookingApi.isLoading && <Loader height="500px" />}
              {bookingApi.isSuccess && (
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  pagination={{ pageSize: 10 }}
                  className="mx-4"
                  scroll={{ x: 1500 }}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* PAYMENT FORM MODAL */}
      <Modal
        show={paymentFormModal}
        onHide={() => setPaymentFormModal(null)}
        size="lg"
        centered
      >
        <Modal.Body>
          <h4 className="mb-4 fs-5">Payment Details</h4>
          {(orderByIdApi.isLoading || paymentByIdApi.isLoading) && (
            <Loader height={500} />
          )}
          {(orderByIdApi.isError || paymentByIdApi.isError) && (
            <div className="alert alert-danger">
              <p>Error loading payment data. Please try again.</p>
            </div>
          )}
          {orderByIdApi.isSuccess && paymentByIdApi.isSuccess && (
            <AddPaymentForm
              handleSubmit={handleAddPayment}
              totalAmount={
                orderByIdApi?.data?.data[0]?.subTotal ||
                paymentFormModal?.netAmount ||
                0
              }
              setPaymentFormModal={setPaymentFormModal}
              data={{
                discountType:
                  paymentFormModal?.discountType ||
                  orderByIdApi?.data?.data[0]?.discountType,
                discount: orderByIdApi?.data?.data[0]?.discount || 0,
                paidAmount: orderByIdApi?.data?.data[0]?.amountPaid || 0,
                paymentType: paymentByIdApi?.data?.data?.[0]?.paymentType || "",
                utrNumber: paymentByIdApi?.data?.data?.[0]?.utrNumber || "",
                notes: paymentByIdApi?.data?.data?.[0]?.notes || "",
                specialInstruction: "",
                orderId:
                  paymentFormModal?.orderId ||
                  orderByIdApi?.data?.data[0]?.orderId,
                paidAmount:
                  paymentByIdApi?.data?.data?.reduce(
                    (acc, payment) => acc + (payment.amount || 0),
                    0
                  ) || 0,
              }}
            />
          )}
          {!orderByIdApi.isLoading &&
            !paymentByIdApi.isLoading &&
            !orderByIdApi.isSuccess &&
            !paymentByIdApi.isSuccess && (
              <div className="alert alert-warning">
                <p>No data available. Please try again.</p>
              </div>
            )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SalesHistory;
